import NFA from 'shared/helpers/analytics/NFAnalytics';

export const canShowPDPMeasurements = (config?: string) => config === 'true';

export interface SizeTrackingData {
  selectedSizesList: string[];
  selectedSize: string;
  selected_size?: string;
  variantProductID?: string;
  variant_product_id?: string;
  interaction_location?: string;
  mrp_price?: number;
  discounted_price?: number;
  product_id?: string;
  catalog_tag?: string[];
  catalogTagFilter?: string;
  interactionLocation?: string;
  analyticsContext?: Record<string, unknown>;
}
export const trackSizeSelection = (sizeTrackingData: SizeTrackingData) => {
  const { catalog_tag, catalogTagFilter, interactionLocation, analyticsContext, ...rest } = sizeTrackingData;
  NFA.track({
    event: 'product_size_clicked',
    data: {
      ...rest,
      sizeSelectionCount: sizeTrackingData?.selectedSizesList?.length,
      ...(sizeTrackingData.interaction_location
        ? {
            interaction_location: sizeTrackingData.interaction_location,
            mrp_price: sizeTrackingData.mrp_price,
            discounted_price: sizeTrackingData.discounted_price,
            product_id: sizeTrackingData.product_id,
            variant_product_id: sizeTrackingData.variant_product_id,
          }
        : {}),
      ...(catalog_tag ? { catalog_tags: catalog_tag } : {}),
      ...(catalogTagFilter ? { catalog_tag_filter: catalogTagFilter } : {}),
      ...(interactionLocation ? { interaction_location: interactionLocation } : {}),
      ...analyticsContext,
      selected_size: sizeTrackingData.selected_size ?? sizeTrackingData.selectedSize,
      variant_product_id: sizeTrackingData.variant_product_id ?? sizeTrackingData.variantProductID,
    },
  });
};
